import { FunctionComponent, useRef } from 'react'
import * as S from './styled'
import { ReactComponent as DropDownArrowIcon } from '../../atoms/Icons/DropDownArrow.svg'

type OwnProps = {
  setSortBy: any
}
export enum SortBy {
  SETTLEMENTDATE_DESCENDING = 'Avräkningsdatum fallande',
  SETTLEMENTDATE_ASCENDING = 'Avräkningsdatum stigande',
  FILENAME_ASCENDING = 'Filnamn A-Ö',
  FILENAME_DESCENDING = 'Filnamn Ö-A',
  UPLOADDATE_ASCENDING = 'Uppladdningsdatum stigande',
  UPLOADDATE_DESCENDING = 'Uppladdningsdatum fallande',
  UPLOADEDBY_ASCENDING = 'Uppladdat av A-Ö',
  UPLOADEDBY_DESCENDING = 'Uppladdat av Ö-A',
}

const sortOptions = Object.values(SortBy)

type Props = OwnProps

const DocumentSort: FunctionComponent<Props> = ({ setSortBy }) => {
  const dropDownRef = useRef<any>(null)

  function changeHandler(event: any) {
    const value = event.target.options[event.target.options.selectedIndex].value
    setSortBy(value)
  }

  return (
    <S.Container>
      <S.StyledBoldText>Sortera: </S.StyledBoldText>
      <S.DropDown id="drop-down" onChange={changeHandler} ref={dropDownRef}>
        {sortOptions.map(item => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </S.DropDown>
      <DropDownArrowIcon />
    </S.Container>
  )
}

export default DocumentSort
